import styled from 'styled-components';

export const ColumnInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.125rem;
    max-width: 500px;
    width: 100%;

    & div {
        display: flex;
        gap: 0.5rem;
        padding-left: 0.125rem;
        align-items: center;
        text-align: left;
    }
`;
